exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".myback{background:-webkit-linear-gradient(top,#fff,#a5a9c5)!important;color:#2a3686!important}", ""]);

// exports
